import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import {
  metricTitleMap,
  pcConsoleGameMetric,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/baseConfig';
import { getMobileDetailDownloadTitle } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseSetting';
import { pipe } from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import {
  setGameTitle,
  setItem,
  setMetricTitle,
  setPercentForPCConsole,
  setTitleByCompanyShow,
  setTitleByDateMethod,
  setTitleByGenreShow,
  setTitleByPlatform,
  setTitleByRegionMethod,
  setTitleByReleaseDateShow,
  setTitleBySteamIdShow,
  setTitleBySteamTagsShow,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/titleSettingAtom';
const newMetricMap = {
  ...metricTitleMap,
  ...pcConsoleGameMetric,
};
const sourceDownloadSegment: Record<string, string[]> = {
  mscience: [
    'All',
    'Full Game',
    'DLC: All Other',
    'DLC: Expansion',
    'DLC: Season Pass',
    'DLC: Battle Pass',
    'MTX',
    'Subscription',
  ],
  gsd: ['All', 'Full Game', 'Game', 'Add-On', 'In-Game Currency'],
  vginsights: ['All'],
  newzoo: ['All'],
  newzoo_weight: ['All'],
  npd: ['All'],
};
const mergeData = function (params: Record<string, any> = {}) {
  const result: { Metric: string; Segment?: string; Source: string }[] = [];

  let segments = sourceDownloadSegment;
  // 如果是新segment且包含metric_condition字段，则做过滤
  if (params?.metric_condition) {
    const newMetricCondition = params?.metric_condition || {};
    const newMetricObj: any = { ...newMetricCondition };
    Object.entries(newMetricObj)?.forEach(([key, value]) => {
      newMetricObj[key] = value?.segments || [];
    });
    segments = {
      ...segments,
      ...newMetricObj,
    };
  }
  const metrics = params?.source_metrics || {};
  // 遍历 source_metric 中的每个键
  Object.keys(metrics)?.forEach((key) => {
    // 获取当前键对应的 metrics 数组
    const currentMetrics = metrics?.[key] || [];
    // 获取当前键对应的 segments 数组
    const currentSegments = segments?.[key] || [];

    // 遍历 metrics 数组
    currentMetrics?.forEach((metric: any) => {
      // 遍历 segments 数组
      if (params?.segment_method === 'aggregated') {
        result.push({ Metric: metric, Source: '' });
      } else {
        if (currentSegments?.length) {
          currentSegments?.forEach((segment: any) => {
            // 将结果添加到结果数组中
            result.push({ Metric: metric, Segment: segment, Source: '' });
          });
        } else {
          result.push({ Metric: metric, Segment: '', Source: '' });
        }
      }
    });
  });

  return result;
};
const getSheetNames = (params: Record<string, any> = {}) => {
  const metricList = mergeData(params);
  const pipeFront = pipe(
    setGameTitle,
    setTitleByDateMethod(params?.downlaod_date_method),
    setTitleByCompanyShow(params?.company_show),
    setTitleByGenreShow(params?.genre_show),
    setTitleBySteamTagsShow(params?.steam_tag_show),
    setTitleByReleaseDateShow(params?.release_date_show),
    setTitleBySteamIdShow(params?.steam_id_show),
    setTitleByRegionMethod(params?.region_method),
    setTitleByPlatform(params?.device_method),
  );
  const pipeInLoop = pipe(
    setItem,
    setMetricTitle(newMetricMap, params?.date_type, 'isObject'),
    setPercentForPCConsole(params?.ratio_show),
  );

  const excelTitleList = getMobileDetailDownloadTitle(pipeFront, metricList, pipeInLoop);
  const sheetNames = params?.date_method !== 'aggregated' ? 'Stats-Monthly' : 'Stats';
  return {
    sheetName: [sheetNames],
    [sheetNames]: excelTitleList,
  };
};

// 外部传入数据，转为下载接口所需要参数
const getDownloadApiParams = (params: any) => {
  if (params?.overlap_source === 'ampere') {
    const downloadRegionType = params?.download_region_type === 'country'
      ? 'market'
      : params?.download_region_type || params?.region_type || 'region';
    return {
      combined_id: params?.combined_id,
      start_date: params?.start_date,
      end_date: params?.end_date,
      storefronts: params?.storefronts || [],
      platforms: params?.platforms || [],
      region_type: params?.region_type || 'region',
      region: params?.region || 'global',
      steam_tag: params?.steam_tag || [],
      steam_tag_relation: params?.steam_tag_relation || 'and',
      iegg_genre_req: params?.iegg_genre_req || [],
      active_users_range: params?.active_users_range || {},
      order: params?.order || 'desc',
      page: 1,
      page_size: 99999,
      download_region_type: downloadRegionType,
      download_regions: params?.download_regions || [params?.region || 'global'],
      company_show: params?.company_show,
      genre_show: params?.genre_show,
      release_date_show: params?.release_date_show,
      steam_tag_show: params?.steam_tag_show,
      file_format: params?.file_format,
    };
  }
  const apiParams: any = {
    order_metric: params?.order_metric,
    order: params?.order,
    page_name: params?.page_name,
    page: 1,
    page_size: 99999,
    engagement_level_a: params?.engagement_level_a,
    engagement_level_b: params?.engagement_level_b,
    region_type: params?.region_type,
    region: params?.region,
    metrics: params?.metrics,
    metric_filter: params?.metric_filter,
    id: params?.id,
    download_region_type: params?.download_region_type || params?.region_type,
    download_regions: params?.download_regions || [params?.region],
  };
  // 新增 Steam Tags 参数
  if (Array.isArray(params?.steam_tag) && params.steam_tag.length > 0) {
    apiParams.steam_tag = params.steam_tag;
    apiParams.steam_tag_relation = params.steam_tag_relation || 'and';
  }
  // 新增 IEGG Genre 参数
  if (Array.isArray(params?.iegg_genre_req) && params.iegg_genre_req.length > 0) {
    apiParams.iegg_genre_req = params.iegg_genre_req;
  }
  return apiParams;
};

const getSummarySheet = () => {
  const list: any[] = [];
  return list;
};

const granularityObject: Record<string, string> = {
  daily: 'D',
  weekly: 'W',
  monthly: 'M',
};

const getFileName = (params: any) => {
  const {
    start_release_time,
    start_date,
    end_release_time,
    end_date,
    granularity,
    new_style_donwload_file_name,
  } = params;
  const gItem = granularityObject?.[granularity];
  if (start_date && end_date) {
    return `${new_style_donwload_file_name}_${start_date}_${end_date}`;
  }
  if (start_release_time && end_release_time) {
    return `${new_style_donwload_file_name}_Release_${gItem}${start_release_time}_${gItem}${end_release_time}`;
  }
  return `${new_style_donwload_file_name}`;
};

export default (params: Record<string, any>) => {
  const isAmpereOverlap = params?.overlap_source === 'ampere';
  return {
    ...commonSetting,
    isUsingNewMethod: false,
    $$fileName: getFileName(params),
    downloadFetchApi: isAmpereOverlap
      ? '/api/v1/intelligence_pc/detail/ampereOverlapGame'
      : '/api/v1/intelligence_pc/detail/steamOverlapGame',
    dataKey: undefined,
    summarySheet: getSummarySheet(),
    regionOptions: params?.regionOptions,
    byDate: params?.downlaod_date_method !== 'aggregated',
    granularity: granularityObject[params?.granularity],
    isRelease: !!(params?.end_release_time && params?.start_release_time),
    downloadApiParams: getDownloadApiParams(params),
    fetchOnlyOnce: true,
    downloadMode: 'commonConf',
    downloadConfigKey: isAmpereOverlap
      ? 'pc_console_ampere_overlap'
      : 'pc_console_steam_overlap',
    ...getSheetNames(params),
  };
};
